(() => {
if (window.__pgsLoaded) return; window.__pgsLoaded = 1;
const R = document;
const once = window.__pgsOnce || (window.__pgsOnce = {});
const done = (el, k) => { if (!el) return true; const key = 'pgs' + k; if (el.dataset[key]) return true; el.dataset[key] = '1'; return false; };
const init = () => {
  const body = R.querySelector('[data-pg-body]');

  if (body) ['signatur','produkter','fra-butikken','cta'].forEach(k => {
    const ph = body.querySelector('[data-guide="' + k + '"]'); const el = R.querySelector('#pg-' + k);
    if (ph && el && k !== 'signatur' && k !== 'cta') ph.replaceWith(el);
  });

  if (body) body.querySelectorAll('table').forEach(t => { if (t.parentElement.classList.contains('pg__tw')) return; const w = document.createElement('div'); w.className = 'pg__tw'; t.before(w); w.append(t); });

  /* Indholdsboks */
  const hs = body ? [...body.querySelectorAll('h2')] : [];
  const targets = [];
  const calc = R.querySelector('#pg-signatur'); if (calc) targets.push([calc, calc.dataset.knap || 'Værktøj', 'is-calc']);
  hs.forEach((h, i) => { if (!h.id) h.id = 'afsnit-' + (i + 1); targets.push([h, h.dataset.toc || h.textContent.replace(/\s+/g, ' ').trim()]); });
  const faq = R.querySelector('#pg-faq'); if (faq) targets.push([faq, 'Spørgsmål og svar']);
  const toc = R.querySelector('[data-pg-toc]');
  if (toc && targets.length > 2) {
    const ol = toc.querySelector('ol'), btn = toc.querySelector('.pg__tocbtn'), tl = toc.querySelector('[data-pg-tocl]');
    ol.innerHTML = '';
    targets.forEach(([el, txt, cls]) => {
      const li = document.createElement('li'), a = document.createElement('a'), sp = document.createElement('span');
      a.href = '#' + el.id; sp.textContent = txt; a.append(sp);
      if (cls) { a.className = cls; const em = document.createElement('em'); em.textContent = 'Værktøj'; a.append(em); }
      li.append(a); ol.append(li);
    });
    if (tl) tl.textContent = targets.length + ' korte afsnit · ca. ' + (toc.dataset.min || 4) + ' min.';
    const fresh = !done(toc, 'Toc');
    const mq = matchMedia('(min-width: 900px)'); const setOpen = o => { toc.classList.toggle('is-closed', !o); btn.setAttribute('aria-expanded', o); }; const sync = () => setOpen(mq.matches); sync(); if (fresh) { mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync); }
    if (fresh) btn.addEventListener('click', () => { if (!mq.matches) setOpen(toc.classList.contains('is-closed')); });
    toc.hidden = false;
    if (fresh) toc.addEventListener('click', e => { const l = e.target.closest('a'); if (!l) return; const t = R.querySelector(l.getAttribute('href')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', l.getAttribute('href')); } });
  }
  /* Links i Kort fortalt: #rum-id → kapitel, rumvælger eller signatur */
  R.querySelectorAll('.pg__kf a[href^="#"]').forEach(a => !done(a, 'Kf') && a.addEventListener('click', e => {
    const h = a.getAttribute('href'); let t = h.length > 1 ? R.querySelector(h) : null;
    if (!t && h.indexOf('#rum-') === 0) { const id = h.slice(5), go = R.querySelector('[data-rum-go="' + id + '"]'); if (go) { go.click(); t = R.querySelector('#pg-signatur'); } else { t = R.querySelector('[data-rum="' + id + '"]') || R.querySelector('#pg-signatur'); } }
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }));

  /* Tidsplan-faner */
  R.querySelectorAll('[data-pgt-plan]').forEach(plan => !done(plan, 'Plan') && plan.addEventListener('click', e => {
    const b = e.target.closest('.pgt__tab'); if (!b) return;
    plan.querySelectorAll('.pgt__tab').forEach(t => t.setAttribute('aria-pressed', t === b ? 'true' : 'false'));
    plan.querySelectorAll('[data-panel]').forEach(p => { p.hidden = p.dataset.panel !== b.dataset.job; });
  }));

  /* Kurv */
  const addItems = async items => {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) throw new Error('cart');
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  };

  /* Malingberegner */
  const f = R.querySelector('[data-pg-calc]');
  if (f && !done(f, 'Calc')) {
    const spild = (+f.dataset.spild || 10) / 100;
    const num = n => { const v = parseFloat(String(f.elements[n].value).replace(',', '.')); return isFinite(v) && v > 0 ? v : 0; };
    const fmt = (v, d = 1) => v.toLocaleString('da-DK', { minimumFractionDigits: d, maximumFractionDigits: d });
    const out = k => R.querySelector('[data-o="' + k + '"]');
    const addBtn = R.querySelector('[data-pg-add]');
    let qty = 0;
    const rooms = [];
    const svg = R.querySelector('[data-pg-room]'), list = R.querySelector('[data-pg-roomlist]'), roomsBox = R.querySelector('[data-pg-rooms]');
    const kr = c => fmt(c / 100, 2) + ' kr';
    const cur = () => ({ l: num('l'), b: num('b'), h: num('h'), a: num('a'), loft: f.elements.loft.checked });
    const area = o => Math.max(0, 2 * (o.l + o.b) * o.h - o.a) + (o.loft ? o.l * o.b : 0);
    const draw = o => {
      if (!svg) return;
      if (!o.l || !o.b || !o.h) { svg.innerHTML = ''; return; }
      const c = Math.cos(Math.PI / 6), sn = 0.5, P = (x, y, z) => [(x - y) * c, (x + y) * sn - z];
      const pts = [[0,0,0],[o.l,0,0],[o.l,o.b,0],[0,o.b,0],[0,0,o.h],[o.l,0,o.h],[o.l,o.b,o.h],[0,o.b,o.h]].map(q => P(...q));
      const xs = pts.map(q => q[0]), ys = pts.map(q => q[1]);
      const minX = Math.min(...xs), maxX = Math.max(...xs), minY = Math.min(...ys), maxY = Math.max(...ys);
      const k = Math.min(250 / (maxX - minX || 1), 128 / (maxY - minY || 1));
      const ox = (320 - (maxX - minX) * k) / 2 - minX * k, oy = (168 - (maxY - minY) * k) / 2 - minY * k;
      const T = (x, y, z) => { const q = P(x, y, z); return [q[0] * k + ox, q[1] * k + oy]; };
      const poly = (cls, a) => '<polygon class="' + cls + '" points="' + a.map(q => T(...q).map(v => v.toFixed(1)).join(',')).join(' ') + '"/>';
      const lab = (t, q, dx, dy, anc) => { const v = T(...q); return '<text x="' + (v[0] + dx).toFixed(1) + '" y="' + (v[1] + dy).toFixed(1) + '" text-anchor="' + (anc || 'middle') + '">' + t + '</text>'; };
      let h = poly('fl', [[0,0,0],[o.l,0,0],[o.l,o.b,0],[0,o.b,0]]);
      h += poly('wl', [[0,0,0],[o.l,0,0],[o.l,0,o.h],[0,0,o.h]]);
      h += poly('wl2', [[0,0,0],[0,o.b,0],[0,o.b,o.h],[0,0,o.h]]);
      if (o.loft) h += poly('ce', [[0,0,o.h],[o.l,0,o.h],[o.l,o.b,o.h],[0,o.b,o.h]]);
      h += poly('ed', [[o.l,0,0],[o.l,o.b,0],[0,o.b,0],[0,o.b,o.h],[o.l,o.b,o.h],[o.l,0,o.h]]);
      h += '<line class="ed" x1="' + T(o.l,o.b,0)[0] + '" y1="' + T(o.l,o.b,0)[1] + '" x2="' + T(o.l,o.b,o.h)[0] + '" y2="' + T(o.l,o.b,o.h)[1] + '"/>';
      h += lab(fmt(o.l) + ' m', [o.l / 2, o.b, 0], -6, 18, 'end');
      h += lab(fmt(o.b) + ' m', [o.l, o.b / 2, 0], 10, 16, 'start');
      h += lab(fmt(o.h) + ' m', [0, o.b, o.h / 2], -8, 4, 'end');
      svg.innerHTML = h;
    };
    const desc = (o, i) => 'Rum ' + i + ': ' + fmt(o.l) + ' × ' + fmt(o.b) + ' m' + (o.loft ? ' + loft' : '') + ' · ' + fmt(area(o)) + ' m²';
    const renderRooms = o => {
      roomsBox.hidden = rooms.length === 0;
      list.innerHTML = rooms.map((r, i) => '<li><span>' + desc(r, i + 1) + '</span><button type="button" data-rm="' + i + '" aria-label="Fjern rum ' + (i + 1) + '">×</button></li>').join('')
        + (rooms.length ? '<li class="is-cur"><span>' + desc(o, rooms.length + 1) + ' (det du taster nu)</span></li>' : '');
    };
    const run = () => {
      const o = cur(), lag = +f.elements.lag.value, r = +f.elements.r.value;
      draw(o); renderRooms(o);
      const areal = rooms.reduce((t, x) => t + area(x), 0) + area(o);
      const liter = areal * lag / r * (1 + spild);
      const p = f.querySelector('input[name="p"]:checked');
      out('liter').textContent = fmt(liter);
      if (!p || liter === 0) { out('tekst').textContent = 'Udfyld rummets mål.'; out('regn').textContent = ''; out('rest').textContent = ''; out('tot').textContent = ''; qty = 0; return; }
      const spand = +p.dataset.liter; qty = Math.max(1, Math.ceil(liter / spand));
      const rest = qty * spand - liter;
      out('tekst').innerHTML = 'Det svarer til <b>' + qty + ' × ' + p.dataset.title + '</b> (' + fmt(qty * spand, spand % 1 ? 1 : 0) + ' liter i alt).';
      out('regn').textContent = (rooms.length ? (rooms.length + 1) + ' rum, ' : '') + fmt(areal) + ' m² × ' + lag + ' lag ÷ ' + r + ' m²/l + ' + Math.round(spild * 100) + ' % spild';
      out('rest').textContent = rest >= 0.5 ? 'Du får ca. ' + fmt(rest) + ' liter til overs. Gem den til pletter og reparationer senere.' : '';
      const acc = [...R.querySelectorAll('[data-acc]:checked')];
      const total = qty * +p.dataset.price + acc.reduce((t, c) => t + +c.dataset.price, 0);
      addBtn.textContent = 'Læg ' + qty + ' spand' + (qty > 1 ? 'e' : '') + (acc.length ? ' + ' + acc.length + ' tilbehør' : '') + ' i kurven';
      out('tot').textContent = 'I alt ' + kr(total);
    };
    R.querySelector('[data-pg-addroom]').addEventListener('click', () => {
      const o = cur(); if (!area(o)) return;
      rooms.push(o); run();
      const l = f.elements.l; l.focus(); l.select();
    });
    list.addEventListener('click', e => { const b = e.target.closest('[data-rm]'); if (b) { rooms.splice(+b.dataset.rm, 1); run(); } });
    f.addEventListener('input', run); f.addEventListener('change', run);
    (f.closest('.pg__calc') || R).addEventListener('change', e => { if (e.target.matches('[data-acc]')) run(); });
    run();
    addBtn.addEventListener('click', async () => {
      const p = f.querySelector('input[name="p"]:checked'); if (!p || !qty) return;
      const items = [{ id: +p.value, quantity: qty }];
      R.querySelectorAll('[data-acc]:checked').forEach(c => items.push({ id: +c.dataset.acc, quantity: 1 }));
      addBtn.disabled = true;
      try { await addItems(items); R.querySelector('[data-pg-ok]').hidden = false; } catch (_) { addBtn.textContent = 'Prøv igen'; }
      addBtn.disabled = false;
    });

  }

  /* Fast knap på mobil: vises først når man er scrollet forbi værktøjet */
  const st = R.querySelector('[data-pg-sticky]');
  if (st && calc && !done(st, 'St')) {
    let q = 0; const intro = R.querySelector('.pg__intro');
    const tick = () => { q = 0; const r = calc.getBoundingClientRect(); const ir = intro ? intro.getBoundingClientRect() : null; st.classList.toggle('is-on', r.bottom < 0 && (!ir || ir.bottom < 0 || ir.top > innerHeight)); };
    addEventListener('scroll', () => { if (!q) q = requestAnimationFrame(tick); }, { passive: true }); tick();
  }

  /* Hurtig-køb (anbefalet-boks og vælger) */
  if (!once.quick) { once.quick = 1; R.addEventListener('click', async e => {
    const b = e.target.closest('[data-quick]'); if (!b || b.disabled) return;
    b.disabled = true;
    try {
      await addItems([{ id: +b.dataset.quick, quantity: 1 }]);
      b.classList.add('is-added'); if (b.dataset.label) b.textContent = 'Lagt i kurven ✓';
      setTimeout(() => { b.classList.remove('is-added'); if (b.dataset.label) b.textContent = b.dataset.label; b.disabled = false; }, 2200);
    } catch (_) { b.disabled = false; if (b.dataset.label) b.textContent = 'Prøv igen'; }
  }); }

  /* Vælger */
  const vl = R.querySelector('[data-pg-vlg]');
  if (vl && !done(vl, 'Vlg')) {
    const mark = vl.querySelector('[data-pg-mark]');
    const show = () => {
      const id = (vl.querySelector('input[name="vlg"]:checked') || {}).value; let cur = null;
      vl.querySelectorAll('[data-rum]').forEach(el => { const on = el.dataset.rum === id; el.hidden = !on; if (on) cur = el; });
      if (cur && mark) { mark.style.left = cur.dataset.p + '%'; vl.querySelectorAll('.pg__tick').forEach(t => t.classList.toggle('is-on', t.dataset.v === cur.dataset.glans)); }
    };
    vl.addEventListener('change', show); show();
    R.querySelectorAll('[data-rum-go]').forEach(a => !done(a, 'Go') && a.addEventListener('click', () => { const i = vl.querySelector('input[name="vlg"][value="' + a.dataset.rumGo + '"]'); if (i) { i.checked = true; show(); } }));
  }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();
